define('app-Agents/settings',[],function () {
    return {
    };
});
